import React from 'react';

const DrAeshaLifeBeyondDentistry = () => {
  return (
    <div className="relative min-h-[400px] w-full flex items-center justify-center">
      {/* Gradient background */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-cyan-200 via-yellow-100 to-cyan-200"
        style={{
          backgroundSize: '200% 200%',
          animation: 'gradient 15s ease infinite'
        }}
      />

      {/* Content overlay */}
      <div className="relative text-center max-w-3xl mx-auto px-4 py-16 space-y-6">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-serif text-gray-800 mb-8">
            Life Beyond Dentistry
          </h2>

          <div className="space-y-6 text-gray-700">
            <p className="text-lg text-gray-700 mb-4">
              When Dr. Aesha isn't transforming smiles at the office, you’ll likely find her spending time with her beloved dog on long walks, experimenting with new recipes in the kitchen, or planning her next weekend getaway. She's a curious soul at heart, always looking for something new to explore—whether it's a hidden coffee shop in town or a hiking trail off the beaten path.
            </p>

            <p className="text-lg text-gray-700">
              A lover of cozy movie nights, spontaneous adventures, and good food, Dr. Aesha believes that a fulfilling life outside the office helps her bring even more compassion and creativity to her patients. Her down-to-earth personality and sense of balance shine through in every interaction, making her not just your dentist—but someone you genuinely enjoy seeing.
            </p>

          </div>
        </div>
      </div>

      <style jsx>{`
          @keyframes gradient {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}</style>
    </div>
  );
};

export default DrAeshaLifeBeyondDentistry;